import { render, staticRenderFns } from "./LivroReceitas.vue?vue&type=template&id=1966f33c&"
import script from "./LivroReceitas.vue?vue&type=script&lang=js&"
export * from "./LivroReceitas.vue?vue&type=script&lang=js&"
import style0 from "./LivroReceitas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports